import { useEffect, useState, useRef } from 'react';

export default function HowItWorks() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      number: '1',
      title: 'Kaydol',
      description: 'Telefon veya sosyal medya ile hızlıca kayıt ol',
      icon: 'ri-user-add-line',
    },
    {
      number: '2',
      title: 'Konumunu Belirle',
      description: 'Konum izni ver veya adresini gir, yayın çapını ayarla',
      icon: 'ri-map-pin-line',
    },
    {
      number: '3',
      title: 'Keşfet & Paylaş',
      description: 'İlan ver, duyuru yap, yardım iste veya yakınındakileri keşfet',
      icon: 'ri-share-line',
    },
  ];

  return (
    <section id="how-it-works" ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-4">
            3 Adımda Başla
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Mahallebi'ye katılmak ve komşularınla buluşmak çok kolay
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-[#e77e23]/20 via-[#e77e23] to-[#e77e23]/20"></div>

          <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                <div className="text-center">
                  {/* Number Circle */}
                  <div className="relative inline-flex items-center justify-center w-20 h-20 bg-[#e77e23] rounded-full mb-6 shadow-lg">
                    <span className="text-3xl font-bold text-white">{step.number}</span>
                  </div>

                  {/* Icon */}
                  <div className="w-16 h-16 bg-[#f8f7f6] rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-3xl text-[#e77e23]`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-[#111827] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}